export const SkeletonLoader = () => {
  return (
    <div className="w-full max-w-4xl animate-pulse space-y-3">
      <div className="h-2 bg-slate-700 rounded w-1/5"></div>
      <div className="h-2 bg-slate-700 rounded w-2/5"></div>
      <div className="h-2 bg-slate-700 rounded w-3/5"></div>
      <div className="h-2 bg-slate-700 rounded w-4/5"></div>
      <div className="h-2 bg-slate-700 rounded w-4/5"></div>
      <div className="h-2 bg-slate-700 rounded w-3/5"></div>
      <div className="h-2 bg-slate-700 rounded w-2/5"></div>
      <div className="h-2 bg-slate-700 rounded w-1/5"></div>
      <div className="h-2 bg-slate-700 rounded w-2/5"></div>
      <div className="h-2 bg-slate-700 rounded w-2/5"></div>
      <div className="h-2 bg-slate-700 rounded w-1/5"></div>
      <div className="h-2 bg-slate-700 rounded w-1/5"></div>
      <div className="h-2 bg-slate-700 rounded w-1/5"></div>
      <div className="h-2 bg-slate-700 rounded w-1/6"></div>
      <div className="h-2 bg-slate-700 rounded w-2/5"></div>
      <div className="h-2 bg-slate-700 rounded w-3/5"></div>
    </div>
  )
}
